import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import MenuGroup from './MenuGroup'
import WriteBox from "./WriteBox"
import BlogProfile from './BlogProfile'
import { withRouter } from 'react-router-dom'
import * as RoleType from '../../constants/user/RoleType';
import MenuGroups from '../../constants/common/MenuGroup';

function MenuItem({ menu, role, ico }) {
  if (!RoleType.canAccess(role, menu.requireRole)) {
    return null
  }

  return (
    <div className="wrap_menu">
      <NavLink className="tit_menu tit_line" exact activeClassName="on" to={menu.to} style={{ textDecoration:'none' }}>
        <span className="link_menu"><span className={`ico_blog ${ico}`}/>{menu.name}</span>
      </NavLink>
    </div>
  )
}


@withRouter
@connect(state => ({
  blog: state.blog,
  user: state.user,
  revenue: state.revenue,
}))
class Sidebar extends Component {

  render() {
    const { activePlugins } = this.props.blog;
    const { revenue } = this.props;
    const { role } = this.props.user;
    const currentRole = RoleType.convertStringToRoleType(role);

    return (
      <div id= "mFeature" >
        <BlogProfile />

        <WriteBox />

        <div id="kakaoLnb" className="aside_menu" role="navigation">
          <h3 className="screen_out">블로그 관리센터 메뉴</h3>

          <MenuItem ico='ico_home' menu={MenuGroups.home[0]} role={currentRole} />

          <MenuGroup ico="ico_post" name="콘텐츠" currentRole={currentRole} menu={MenuGroups.content} activePlugins={activePlugins} />

          <MenuGroup ico="ico_reply" name="댓글·방명록" currentRole={currentRole} menu={MenuGroups.comment} />

          <MenuGroup ico="ico_analysis" name="통계" currentRole={currentRole} menu={MenuGroups.stat}/>

          {revenue.tester &&
            <MenuGroup
                ico="ico_revenue" name="수익" currentRole={currentRole} menu={MenuGroups.revenue}
                to="/revenue" // to prop이 존재할경우 title clickable
            />
          }

          <MenuGroup ico="ico_skin" name="꾸미기" currentRole={currentRole} menu={MenuGroups.design}/>

          <MenuItem ico='ico_plugin' menu={MenuGroups.plugin[0]} role={currentRole} />

          <MenuGroup ico="ico_link" name="링크" currentRole={currentRole} menu={MenuGroups.link}/>

          <MenuGroup ico="ico_setting" name="관리" currentRole={currentRole} menu={MenuGroups.setting}/>
        </div>
      </div>
    )
  }
}

export default Sidebar
